import React from 'react';
import Card from 'react-bootstrap/Card';
import withNameInput from './hoc-input';
import withNameSelect from './hoc-select';
import Header from './header';
import Pane from './pane';

const InvestUrl = withNameInput('investUrl', 'Invest URL');
const FundPageUrl = withNameInput('fundPageUrl', 'Fund Page URL');
const PDSFileUrl = withNameInput('pdsFileUrl', 'PDS File URL');
const MonthlyUpdateFileUrl = withNameInput('monthlyUpdateFileUrl', 'Monthly Update File URL');
const MonthlyUpdateUrlType = withNameSelect('monthlyUpdateUrlType', 'Monthly Update Url Type');
const TmdFileUrl = withNameInput('tmdFileUrl', 'TMD File URL');

export default function FilesAndLinks() {
  return (
    <Card>
      <Card.Header>
        <Header eventKey="fandl">Fund Files & Links</Header>
      </Card.Header>
      <Pane eventKey="fandl">
        <Card.Body>
          <InvestUrl />
          <FundPageUrl />
          <PDSFileUrl />
          <MonthlyUpdateFileUrl />
          <MonthlyUpdateUrlType />
          <TmdFileUrl />
        </Card.Body>
      </Pane>
    </Card>
  );
}
